(function () {
  'use strict';

  var section = document.querySelector('.odms26autumn-programm');
  if (!section) return;

  // Chip filter: smooth-scroll to the matching day group. Booking view only —
  // the preview view renders no chips. Expiry/greying is server-side.
  var SCROLL_OFFSET = 184; // clears the sticky header + tabbar

  section.querySelectorAll('[data-scroll-target]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // prevent Prestige theme.js from hijacking the scroll
      var target = document.getElementById(chip.getAttribute('data-scroll-target'));
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });
})();
